<footer class="footer">
  <div class="container">
    <p class="text-xs-center"><a href="javascript:void(0);"><p (keyup)="$event.key === 'Enter' ? null : null" (click)="showChangelog(true)">Version: {{version}}</p></a></p>
    <p class="text-xs-center"><a href="javascript:void(0);"><p (keyup)="$event.key === 'Enter' ? null : null" (click)="showChangelog(false)">Backend: {{backend_ver}} </p></a></p>
  </div>
</footer>
